// extracted by mini-css-extract-plugin
export default {"form":"ResetPassword_form__inOMu","passwordTip":"ResetPassword_passwordTip__o2ttF","button":"ResetPassword_button__9CiXY","newAccountLink":"ResetPassword_newAccountLink__un5ht"};